<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path d="M13 0H15V3H18V5H15V8H13V5H10V3H13V0Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1.68415C0 1.30636 0.306359 1 0.684145 1H8.5L8.5 6.66667H11.3333V9.5H17V17.3158C17 17.6936 16.6938 18 16.3159 18H0.684145C0.306359 18 0 17.6938 0 17.3158V1.68415ZM10.4236 7.57818V11.4222H6.57962V7.57818H10.4236ZM6.57962 7.57818H2.73563V3.73415H6.57962V7.57818ZM6.57962 11.4222V15.266H2.73563V11.422L6.57962 11.4222ZM10.4236 11.4222L14.2676 11.422V15.266H10.4236V11.4222Z"
    />
  </svg>
</template>
